import {
    Table,
    Row,
    Col,
    Input,
    Button,
    Modal,
} from "reactstrap"
import '../../components/Common/Common.css';
import { useState } from "react";
import {
    setAdmMemberActivityEntitiesStarHideLog,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";

function EntitiesStarHideLogModel({
    toggleEntitiesStarHideLog,
    isEntitiesStarHideLogOpen,
    filterValidation,

}) {

    const dispatch = useDispatch();

    const { entitiesStarHideLog, entitiesStarHideLogActive, entitiesStarHideLogTotalPage, loading } = useSelector(state => ({
        loading: state.admMemberStatistics.loading,
        error: state.admMemberStatistics.error,
        success: state.admMemberStatistics.success,
        noticeStr: state.admMemberStatistics.activityNoticeStr,
        activityList: state.admMemberStatistics.activityList,
        entitiesStarHideLog: state.admMemberStatistics.entitiesStarHideLog,
        entitiesStarHideLogActive: state.admMemberStatistics.entitiesStarHideLogActive,
        entitiesStarHideLogTotalPage: state.admMemberStatistics.entitiesStarHideLogTotalPage,
    }))


    // Search contact log
    const [searchKey, setSearchKey] = useState("");
    const [curPage, setcurPage] = useState(1);
    const [curPageInput, setcurPageInput] = useState(1);

    const viewContactsLogList = (curPage) => {
        setcurPage(curPage);
        setcurPageInput(curPage);

        const startIndex = 10 * (curPage - 1);
        let keyFiltered = entitiesStarHideLog

        if (searchKey != "") {
            keyFiltered = entitiesStarHideLog.filter(contact => {
                return contact.targetGroupName?.toLowerCase().includes(searchKey) ||
                    contact.regUserName?.toLowerCase().includes(searchKey) ||
                    contact.modUserName?.toLowerCase().includes(searchKey)
            })
        }
        const _entitiesStarHideLogActive = keyFiltered.slice(startIndex, Math.min(startIndex + 10, keyFiltered.length))
        dispatch(setAdmMemberActivityEntitiesStarHideLog({ entitiesStarHideLog: entitiesStarHideLog, entitiesStarHideLogActive: _entitiesStarHideLogActive, entitiesStarHideLogTotalPage: entitiesStarHideLogTotalPage }));
    }

    const searchContactsLog = (keywordValue) => {
        keywordValue = keywordValue.toLowerCase();
        setSearchKey(keywordValue);
        setcurPage(1);
        setcurPageInput(1);

        const filtered = entitiesStarHideLog.filter(contact => {
            return contact.targetGroupName?.toLowerCase().includes(keywordValue) ||
                contact.regUserName?.toLowerCase().includes(keywordValue) ||
                contact.modUserName?.toLowerCase().includes(keywordValue)
        })

        const _entitiesStarHideLogActive = filtered.slice(0, Math.min(10, filtered.length))
        dispatch(setAdmMemberActivityEntitiesStarHideLog({ entitiesStarHideLog: entitiesStarHideLog, entitiesStarHideLogActive: _entitiesStarHideLogActive, entitiesStarHideLogTotalPage: Math.max(Math.ceil(filtered.length / 10), 1) }));
    }

    // console.log(isEntitiesStarHideLogOpen, entitiesStarHideLogActive)

    return (
        <Modal
            size="xl"
            style={{ maxWidth: "1700px" }}
            isOpen={isEntitiesStarHideLogOpen && !loading}
            toggle={() => {
                toggleEntitiesStarHideLog(null, null)
            }}
        >
            <div className="modal-body">
                <button
                    onClick={() => {
                        toggleEntitiesStarHideLog(null, null)
                    }}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>

                <div className={""}>
                    <div className="container-fluid">
                        <Row>
                            <Col className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">
                                        {
                                            filterValidation.values.submitType == "viewEntitiesStarLog" ? "Starred entities log" : "Hidden entities log"
                                        }
                                    </h4>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <div className="form-inline float-md-end">
                                <div className="search-box ml-2">
                                    <div className="position-relative">
                                        <Input
                                            type="text"
                                            className="orm-control bg-light border-light rounded"
                                            placeholder="Search..."
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    searchContactsLog(e.target.value);
                                                }
                                            }}
                                        />
                                        <i className="mdi mdi-magnify search-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        {
                            isEntitiesStarHideLogOpen && !loading ? (
                                <>
                                    <Table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Entity</th>
                                                <th>
                                                    {
                                                        filterValidation.values.submitType == "viewEntitiesStarLog" ?
                                                            "Current star" : "Current hide"
                                                    }
                                                </th>
                                                <th>
                                                    {
                                                        filterValidation.values.submitType == "viewEntitiesStarLog" ?
                                                            "First starred date time" : "First hidden date time"
                                                    }
                                                </th>
                                                <th>
                                                    {
                                                        filterValidation.values.submitType == "viewEntitiesStarLog" ?
                                                            "First starred user" : "First hidden user"
                                                    }
                                                </th>
                                                <th>
                                                    Last modified date time
                                                </th>
                                                <th>
                                                    Last modified user
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                entitiesStarHideLogActive 
                                                && Array.isArray(entitiesStarHideLogActive) 
                                                && entitiesStarHideLogActive.length > 0 
                                                && entitiesStarHideLogActive?.map((log, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{log.targetGroupName}</td>
                                                            <td>{log.currentState}</td>
                                                            <td>{log.regDate}</td>
                                                            <td>{log.regUserName}</td>
                                                            <td>{log.modDate}</td>
                                                            <td>{log.modUserName}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                    <div className="d-flex justify-content-end">
                                        <span className="d-flex align-items-center gap-2">
                                            <div className="d-flex gap-1">
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(1); }}
                                                    disabled={(curPage == 1)}
                                                >
                                                    {"<<"}
                                                </Button>
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(Math.max(curPage - 1, 1)); }}
                                                    disabled={(curPage == 1)}
                                                >
                                                    {"<"}
                                                </Button>
                                            </div>
                                            Page{" "}
                                            <strong>
                                                {curPage} of {entitiesStarHideLogTotalPage}
                                            </strong>

                                            <Input
                                                type="number"
                                                min={1}
                                                style={{ width: 70 }}
                                                max={entitiesStarHideLogTotalPage}
                                                name="curPage"
                                                defaultValue={curPage}
                                                value={curPageInput}
                                                onChange={(e) => { setcurPageInput(e.target.value) }}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        viewContactsLogList(e.target.value);
                                                    }
                                                }}
                                            />
                                            <div className="d-flex gap-1">
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(Math.min(curPage + 1, entitiesStarHideLogTotalPage)); }}
                                                    disabled={(curPage == entitiesStarHideLogTotalPage)}
                                                >
                                                    {">"}
                                                </Button>
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(entitiesStarHideLogTotalPage); }}
                                                    disabled={(curPage == entitiesStarHideLogTotalPage)}
                                                >
                                                    {">>"}
                                                </Button>
                                            </div>
                                        </span>
                                    </div>

                                </>

                            ) : <></>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )

}

export default EntitiesStarHideLogModel;